import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { IconDefinition, IconProp } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faHome, faInfoCircle, faLock, faMap, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { TrvNgMapService, TrvNgMapOverlayService, TrvMap } from "@trafikverket/trv-ng-map";
import { TrvGlobalMessagesService, TrvTooltipDirective, TrvTooltipPosition } from "@trv-hub/trv-ng-common";
import {
    svgArrowLeft,
    svgHamburger,
    svgLocation,
    svgMinus,
    svgPerson,
    svgPlus,
    svgPrinter,
    svgRightArrow,
    svgTrafikverketLogo,
} from "src/app/shared/utils/svg-helper-data";
import Geolocation from "ol/Geolocation";

import proj4 from "proj4";
import { register } from "ol/proj/proj4.js";
import { get as getProjection, Projection } from "ol/proj.js";
import { Geometry, Point } from "ol/geom";
import Feature from "ol/Feature";
import { SvgIcon } from "src/app/shared/utils/svg-helper";
import { NavigationState, NvdbNavigationService } from "src/app/service/nvdb-navigation.service";
import { MapComponent } from "../../components/map/map/map.component";
import { SvgIconComponent } from "../../components/utils/svg-icon/svg-icon.component";
import { MapButtonComponent } from "../../components/map/map-button/map-button.component";
import { DataslagSectionComponent } from "../../components/map-menu/dataslag-section/dataslag-section.component";
import { MapButtonsComponent } from "../../components/map/map-buttons/map-buttons.component";
import { MapLabelComponent } from "../../components/map/map-label/map-label.component";
import { environment } from "../../../environments/environment";
import { first, firstValueFrom, skip } from "rxjs";
import { NvdbReportStyle } from "@app/trv-map-extension/trv-map-extension-styles";
import { isStringValidFloat, isStringValidInteger } from "@shared/utils/utils";
import { showErrorMessage } from "@shared/animations";
import { NgClass, NgStyle } from "@angular/common";
import { MobileMapButtonsComponent } from "@app/components/map/mobile-map-buttons/mobile-map-buttons.component";
import { Extent, getCenter } from "ol/extent";
import { Pixel } from "ol/pixel";
import { SearchStyle } from "@app/trv-map-extension/trv-map-extension";
import { LanguageService } from "@app/service/language.service";
import { YearObjectType } from "src/app/service/nvdb-navigation.service";


@Component({
    selector: "app-map-page",
    templateUrl: "./map-page.component.html",
    styleUrls: ["./map-page.component.scss"],
    imports: [
        DataslagSectionComponent,
        MapLabelComponent,
        MapButtonsComponent,
        MapButtonComponent,
        TrvTooltipDirective,
        SvgIconComponent,
        MapComponent,
        NgClass,
        MobileMapButtonsComponent,

    ]
})
export class MapPageComponent implements OnInit {
    //Svg icons
    public locationIcon: SvgIcon = svgLocation;
    public plusIcon: SvgIcon = svgPlus;
    public minusIcon: SvgIcon = svgMinus;
    public svgRightArrow = svgRightArrow;
    public svgArrowLeft = svgArrowLeft;
    public selectedYear!: YearObjectType;
    public availableYearSearchFilter: YearObjectType[] = [];

    public title: string = "NVDB dataleverans";
    public SWEREF_99_TM = registerProjection(
        "EPSG:3006",
        'PROJCS["SWEREF99 TM", GEOGCS["SWEREF99", DATUM["SWEREF99", SPHEROID["GRS 1980",6378137,298.257222101], TOWGS84[0,0,0,0,0,0,0]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4619"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",15], PARAMETER["scale_factor",0.9996], PARAMETER["false_easting",500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","3006"]]'
    );

    public toolTipPositions: TrvTooltipPosition[] = ["left", "bottom"];
    public toolTipPositionTop: TrvTooltipPosition[] = ["top"];

    east: number | null = null;
    north: number | null = null;
    scale: number | null = null;

    wmsLayerIds: string[] = [];
    backgroundLayerId: string | undefined = undefined;

    constructor(
        @Inject(TrvGlobalMessagesService)
        private globalMessagesService: TrvGlobalMessagesService,
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        @Inject(NvdbNavigationService)
        public nvdbNavigation: NvdbNavigationService,
        private route: ActivatedRoute,
        private router: Router,
        public lang: LanguageService
    ) {
        this.nvdbNavigation.hideHamburgerMenu = false;
    }

    async ngOnInit() {

        // Get availableYearSearchFilter from the service
        this.availableYearSearchFilter = this.nvdbNavigation.availableYearSearchFilter;

        this.trvMapService.onMapLoaded().subscribe(() => {
            //console.log("Map loaded, checking URL parameters...");
            
        });

        this.route.queryParams.subscribe(params => {

            this.setUrlMapData(params);

        });
        /*this.route.queryParams.subscribe(params => {

            this.setUrlMapData(params);

            const year = params['year'];

            if (!year) {
                // Om inget year finns i URL → sätt default
                const defaultYear = this.availableYearSearchFilter[0];
                this.updateYearInUrl(defaultYear.displayYear);
                return;
            }

            const foundYear = this.availableYearSearchFilter.find(
                y => y.displayYear === year
            );

            if (foundYear) {
                this.selectedYear = foundYear;
                this.nvdbNavigation.searchMenuState.yearObject.patchValue(foundYear);
                //this.nvdbNavigation.searchMenuState.yearObject.value();
                console.log(this.nvdbNavigation.searchMenuState.yearObject.value)
            }
        });*/
    }

    ngAfterViewInit() {

        if (!this.trvMapService.trvMap) {
            console.error('trvMap is not initialized');
            return;
        }

    }




    private updateYearInUrl(year: string) {
        const currentYear = this.route.snapshot.queryParams['year'];

        if (currentYear === year) return; // stoppa loop

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { year },
            queryParamsHandling: 'merge',
        });
    }

    public onYearChange(selectedYear: YearObjectType) {
        this.updateYearInUrl(selectedYear.displayYear);
    }

    public zoomIn() {
        const view = this.trvMapService.trvMap?.map.getView();
        //view?.setZoom(view?.getZoom()! + 1);
        view?.animate({
            zoom: view?.getZoom()! + 1,
            duration: 500,
        })

    }

    public zoomOut() {
        const view = this.trvMapService.trvMap?.map.getView();
        //view?.setZoom(view?.getZoom()! - 1);

        view?.animate({
            zoom: view?.getZoom()! - 1,
            duration: 500,
        })


    }

    public gotoUserLocation() {
        const proj = this.trvMapService.trvMap?.map.getView().getProjection();

        const geolocation = new Geolocation({
            projection: this.SWEREF_99_TM?.getCode()!,
        });

        geolocation.once("change:position", () => {
            const coordinates = geolocation.getPosition();
            if (coordinates) {
                const point = new Point(coordinates);
                const feature = new Feature(point);
                this.trvMapService.trvMap?.map.getView().fit(feature.getGeometry()!.getExtent(), {
                    padding: [50, 50, 50, 50],
                    maxZoom: 11,
                    duration: 0,
                    callback: () => {
                        const panPixel = this.nvdbNavigation.getViewableCenterPixelOnMainMap()
                        // pan slightly lower for points since their image is above them
                        if (feature.getGeometry()?.getType() == "Point") {
                            panPixel[1] += 60
                        }

                        setTimeout(() => {
                            this.trvMapService.trvMap!.panToFeatureOffsetLocalPixel(feature, panPixel, 600);
                        }, 50);

                    }
                })


                this.trvMapService.trvMap?.trvLayer.tempLayer!.getSource()?.clear();

                if (feature) {
                    feature.setStyle(SearchStyle);

                    this.trvMapService.trvMap?.trvLayer.addFeature(feature, this.trvMapService.trvMap?.trvLayer.tempLayer!);
                }
                geolocation.setTracking(false);
            }
        });

        geolocation.setTracking(true);
    }


    setUrlMapData(params: Params) {
        // sets the map values based on data from the url
        // currently supports position, background and wmsLayers
        // example url: /map?east=527764&north=6707199&scale=1000&backgroundLayer=Ortofoto_0.5&wmslayers=Trafiksakerhetsklass_passage_GCM
        const eastValidNumber = isStringValidFloat(params["east"]);
        const northValidNumber = isStringValidFloat(params["north"]);
        const scaleValidNumber = isStringValidFloat(params["scale"]);

        this.backgroundLayerId = params["backgroundLayer"];
        this.wmsLayerIds = params["wmslayers"] != undefined ? params["wmslayers"].split("|") : [];

        // coordinates
        const anyCoordinatesGiven = params["east"] || params["north"] || params["scale"];
        const allCoordinatesValid = eastValidNumber && northValidNumber && scaleValidNumber;

        if (anyCoordinatesGiven && !allCoordinatesValid) {
            let felaktigtFält = "";
            if (!eastValidNumber) felaktigtFält = "east";
            else if (!northValidNumber) felaktigtFält = "north";
            else felaktigtFält = "scale";

            this.globalMessagesService.error(`Ett fel uppstod när "${felaktigtFält}" skulle läsas. Kan ej zooma till punkt.`);
            return;
        }

        this.east = parseInt(params["east"]);
        this.north = parseInt(params["north"]);
        this.scale = parseInt(params["scale"]);
    }

    protected readonly document = document;
}



export function registerProjection(name: string, projection: string): Projection | null {
    proj4.defs(name, projection);
    register(proj4);
    return getProjection(name);
}

